module.exports = __webpack_public_path__ + "img/sm.f1d0795.svg";